// Utility functions for timer formatting
// These functions are used by create-timer-yash.js and need to be globally available

function pad(number, length) {
  var str = '' + number;
  while (str.length < length) { str = '0' + str; }
  return str;
}

function formatTime(time) {
  var min = parseInt(time / 6000),
    sec = parseInt(time / 100) - (min * 60),
    hundredths = pad(time - (sec * 100) - (min * 6000), 2);
  return (min > 0 ? pad(min, 2) : "00") + ":" + pad(sec, 2);
}

// Make functions globally available
window.pad = pad;
window.formatTime = formatTime;
